import { useEffect, useState } from "react";
import { homeStoryChapters } from "../home-story-data";

type HomeLoaderProps = { progress: number; finished: boolean };

const EXIT_MS = 1100;

/** 进场加载页：五个创作步骤随进度依次点亮，完成后整块幕布上移露出首页。 */
export function HomeLoader({ progress, finished }: HomeLoaderProps) {
  const [mounted, setMounted] = useState(true);

  useEffect(() => {
    const root = document.documentElement;
    if (!mounted) return;
    root.style.overflow = "hidden";
    return () => {
      root.style.overflow = "";
    };
  }, [mounted]);

  useEffect(() => {
    if (!finished) return;
    const timer = window.setTimeout(() => setMounted(false), EXIT_MS);
    return () => window.clearTimeout(timer);
  }, [finished]);

  if (!mounted) return null;
  const step = 100 / homeStoryChapters.length;

  return (
    <div className={`home-loader${finished ? " is-leaving" : ""}`} aria-hidden={finished}>
      <div className="home-loader-brand">
        <img src="/icon-192.png" alt="" width={36} height={36} />
        <span>MoodShow</span>
      </div>
      <ol className="home-loader-steps" aria-hidden="true">
        {homeStoryChapters.map((chapter, index) => (
          <li key={chapter.id} className={progress >= step * (index + 1) - 4 ? "is-lit" : ""}>
            <b>{chapter.number.padStart(2, "0")}</b>
            {chapter.title}
          </li>
        ))}
      </ol>
      <div
        className="home-loader-count"
        role="progressbar"
        aria-label="正在加载 MoodShow 首页"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
      >
        {String(progress).padStart(3, "0")}
      </div>
      <span className="home-loader-line" aria-hidden="true"><i style={{ transform: `scaleX(${progress / 100})` }} /></span>
    </div>
  );
}
